import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ExchangeHistoryFilter from "./ExchangeHistoryFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ExchangeHistoryList from "./ExchangeHistoryList";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";

import { AppContext } from "../../../../App";

import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialPagination from "../../../styles/materialPagination";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledExchangeHistoryWrapper } from "../../styledExchange";
import eventBus from "../../../../utils/eventBus.utils";

const ExchangeHistoryContainer = () => {
  const history = useHistory();
  const { t } = useTranslation("exchangerPage");

  const { exchanger } = useContext(AppContext);

  const { showExchanger, setShowExchanger } = exchanger;

  const [exchangeHistory, setExchangeHistory] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "id": checkFilterItem(history, "id", null),
    "pair.exchangePair.inService.name": checkFilterItem(history, "pair.exchangePair.inService.name", null),
    "pair.exchangePair.outService.name": checkFilterItem(history, "pair.exchangePair.outService.name", null),
    "pair.exchangePair.inCurrency.asset": checkFilterItem(history, "pair.exchangePair.inCurrency.asset", null),
    "pair.exchangePair.outCurrency.asset": checkFilterItem(history, "pair.exchangePair.outCurrency.asset", null),
    "inAmount[gte]": checkFilterItem(history, "inAmount[gte]", null, true),
    "inAmount[lte]": checkFilterItem(history, "inAmount[lte]", null, true),
    "outAmount[gte]": checkFilterItem(history, "outAmount[gte]", null, true),
    "outAmount[lte]": checkFilterItem(history, "outAmount[lte]", null, true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchExchanges = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/exchanges" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setExchangeHistory(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  const toggleExchangerDrawer = () => {
    setShowExchanger(!showExchanger);
  };

  useEffect(() => {
    fetchExchanges();
  }, [filterData]);

  useEffect(() => {
    eventBus.on("exchangeEvent", () => {
      fetchExchanges();
    });
    eventBus.remove("exchangeEvent");
  }, []);

  //TODO Add pusher

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledExchangeHistoryWrapper>
          <div className="exchange-history-head">
            <ExchangeHistoryFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <div className="exchange-history-head__create">
              <DefaultButton
                color="success"
                onClick={toggleExchangerDrawer}
              >
                {t("exchanger.exchangeBtn")}
              </DefaultButton>
            </div>
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ExchangeHistoryList exchangeHistory={exchangeHistory} />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledExchangeHistoryWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ExchangeHistoryContainer;